<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="back" @click="$router.go(-1)" />

      <router-link
        :to="{
          path: BACKEND_URL + '/organisations/edit/' + organisation.id,
          props: { id: organisation.id }
        }"
        v-if="$can('organisation-edit')"
      >
        <action-button type="edit" />
      </router-link>

      <action-button type="delete" @click="del(organisation.id)" v-if="$can('organisation-delete')" />
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="organisation.name"
                  v-model="organisation.name"
                  :label="$t('organisations.name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="organisation.email"
                  v-model="organisation.email"
                  :label="$t('organisations.email')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="organisation.vat"
                  v-model="organisation.vat"
                  :label="$t('organisations.vat')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="organisation.phone"
                  v-model="organisation.phone"
                  :label="$t('organisations.phone')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-checkbox name="organisation.owner" v-model="organisation.owner" :label="$t('organisations.owner')" readonly></v-checkbox>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-checkbox
                  name="organisation.certification_authority"
                  v-model="organisation.certification_authority"
                  :label="$t('organisations.certification_authority')"
                  readonly
                ></v-checkbox>
              </v-flex>
              <!--<v-flex lg2 md4 sm6 xs12>
                                <label>{{ $t('organisations.certification_agencies') }}</label>
                                <ul>
                                    <li v-for="item in allowed_certification_agencies" :key="item.id">{{ item.name }}</li>
                                </ul>
                            </v-flex>
                            <v-flex lg2 md4 sm6 xs12>
                                <label>{{ $t('organisations.course_type_groups') }}</label>
                                <ul>
                                    <li v-for="item in allowed_coursetypegroups" :key="item.id">{{ item.name }}</li>
                                </ul>
                            </v-flex>-->
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar flat dense color="secondary">
            <v-toolbar-title class="subheading">{{ $t("organisations.invoice_title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="organisation.po_number"
                  :label="$t('organisations.po_number')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="organisation.invoice_ref"
                  :label="$t('organisations.invoice_ref')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="organisation.email_invoice"
                  :label="$t('organisations.email_invoice')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar flat dense color="secondary">
            <v-toolbar-title class="subheading">{{ $t("organisations.visiting_address_title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="visiting_address.street"
                  v-model="visiting_address.street"
                  :label="$t('organisations.visiting_street')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg1 md4 sm6 xs12>
                <v-text-field
                  name="visiting_address.zip"
                  v-model="visiting_address.zip"
                  :label="$t('organisations.visiting_zip')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="visiting_address.city"
                  v-model="visiting_address.city"
                  :label="$t('organisations.visiting_city')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="visiting_addressg.state"
                  v-model="visiting_address.state"
                  :label="$t('organisations.visiting_state')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="visiting_address.country"
                  :value="this.$dd_countries(visiting_address.country)"
                  :label="$t('organisations.visiting_country')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar flat dense color="secondary">
            <v-toolbar-title class="subheading">{{ $t("organisations.invoice_address_title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="invoice_address.street"
                  v-model="invoice_address.street"
                  :label="$t('organisations.invoice_street')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg1 md4 sm6 xs12>
                <v-text-field
                  name="invoice_address.zip"
                  v-model="invoice_address.zip"
                  :label="$t('organisations.invoice_zip')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="invoice_address.city"
                  v-model="invoice_address.city"
                  :label="$t('organisations.invoice_city')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="invoice_address.state"
                  v-model="invoice_address.state"
                  :label="$t('organisations.invoice_state')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="invoice_address.country"
                  :value="this.$dd_countries(invoice_address.country)"
                  :label="$t('organisations.invoice_country')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar flat dense color="secondary">
            <v-toolbar-title class="subheading">{{ $t("persons.title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md12>
                <v-data-table
                  :headers="person_headers"
                  :items="persons"
                  :items-per-page="persons.length"
                  :options.sync="person_pagination"
                  :footer-props="{
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="person_total"
                  :loading="person_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template v-slot:item.organisation_id="{ item }">
                    {{ item.organisation.name }}
                  </template>

                  <template v-slot:item.email="{ item }">
                    {{ item.user.email }}
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar flat dense color="secondary">
            <v-toolbar-title class="subheading">{{ $t("organisations.certification_agencies") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md12>
                <v-data-table
                  :headers="ca_headers"
                  :items="certification_agencies"
                  :items-per-page="certification_agencies.length"
                  :options.sync="ca_pagination"
                  :footer-props="{
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="ca_total"
                  :loading="ca_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar flat dense color="secondary">
            <v-toolbar-title class="subheading">{{ $t("organisations.course_type_groups") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md12>
                <v-data-table
                  :headers="ctg_headers"
                  :items="allowed_coursetypegroups"
                  :items-per-page="allowed_coursetypegroups.length"
                  :options.sync="ctg_pagination"
                  :footer-props="{
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="ctg_total"
                  :loading="ctg_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template v-slot:item.status="{ item }">
                    {{ $dd_course_type_groups_status(item.status) }}
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar flat dense color="secondary">
            <v-toolbar-title class="subheading">{{ $t("organisations.course_types") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md12>
                <v-data-table
                  :headers="ct_headers"
                  :items="allowed_coursetypes"
                  :items-per-page="allowed_coursetypes.length"
                  :options.sync="ct_pagination"
                  :footer-props="{
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="ct_total"
                  :loading="ct_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template v-slot:item.status="{ item }">
                    {{ $dd_course_types_status(item.status) }}
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "OrganisationView",

  props: ["id"],

  data() {
    return {
      page_title: "",
      organisation: {},
      visiting_address: {},
      invoice_address: {},
      persons: [],
      certification_agencies: [],
      allowed_coursetypegroups: [],
      allowed_coursetypes: [],
      ca_ids: [],
      ctg_ids: [],
      ct_ids: [],
      url: "",
      person_total: 0,
      person_show_loading: false,
      person_refresh: false,
      person_pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },
      person_headers: [
        { text: this.$t("persons.first_name"), value: "first_name" },
        { text: this.$t("persons.middle_name"), value: "middle_name" },
        { text: this.$t("persons.last_name"), value: "last_name" },
        { text: this.$t("persons.email"), value: "email" },
        { text: this.$t("organisations.title"), value: "organisation_id" },
        { text: this.$t("persons.mobile"), value: "mobile" }
      ],
      ca_total: 0,
      ca_show_loading: false,
      ca_refresh: false,
      ca_pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },
      ca_headers: [{ text: this.$t("organisations.name"), value: "name" }],
      ctg_total: 0,
      ctg_show_loading: false,
      ctg_refresh: false,
      ctg_pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },
      ctg_headers: [
        { text: this.$t("coursetypegroups.name"), value: "name" },
        { text: this.$t("coursetypegroups.category"), value: "category" },
        { text: this.$t("coursetypegroups.status"), value: "status" }
      ],
      ct_total: 0,
      ct_show_loading: false,
      ct_refresh: false,
      ct_pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },
      ct_headers: [
        { text: this.$t("coursetypes.name"), value: "name" },
        { text: this.$t("coursetypes.category"), value: "category" },
        { text: this.$t("coursetypes.status"), value: "status" }
      ]
    }
  },

  created() {
    axios
      .get(this.API_URL + "organisation/" + this.id)
      .then((res) => {
        this.organisation = res.data.data
        this.visiting_address = res.data.data.addresses.visiting
        this.invoice_address = res.data.data.addresses.invoice
        ;(this.ca_ids = this.organisation.allowed_certification_agencies.map((a) => a.id)),
          (this.ctg_ids = this.organisation.allowed_coursetypegroups.map((a) => a.id)),
          (this.ct_ids = this.organisation.allowed_coursetypes.map((a) => a.id)),
          (this.page_title = this.$t("organisations.view_organisation", {
            name: this.organisation.name
          }))

        this.persons_list()
        this.ca_list()
        this.ctg_list()
        this.ct_list()
      })
      .catch((err) => console.log(err))
  },

  watch: {
    person_refresh: {
      handler() {
        if (this.person_refresh && this.organisation.id) {
          this.persons_list()
        }
      }
    },
    ca_refresh: {
      handler() {
        if (this.ca_refresh && this.organisation.id) {
          this.ca_list()
        }
      }
    },
    ctg_refresh: {
      handler() {
        if (this.ctg_refresh && this.organisation.id) {
          this.ctg_list()
        }
      }
    },
    ct_refresh: {
      handler() {
        if (this.ct_refresh && this.organisation.id) {
          this.ct_list()
        }
      }
    },
    pagination: {
      handler() {
        this.refresh = true
      }
    }
  },

  methods: {
    persons_list() {
      this.person_show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.person_pagination
      let query = this.$queryString(this.person_pagination, {
        organisation_id: this.organisation.id
      })

      axios
        .get(this.API_URL + "persons" + "?" + query)
        .then((res) => {
          this.persons = res.data.data
          this.person_total = res.data.meta.total
          this.person_refresh = false
          this.person_show_loading = false

          this.person_pagination.page = res.data.meta.current_page
          this.person_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },

    ca_list() {
      this.ca_show_loading = true

      let ids = this.ca_ids.join(",")
      let { sortBy, descending, page, itemsPerPage } = this.ca_pagination
      let query = this.$queryString(this.ca_pagination, {
        id: ids ? ids : null
      })

      axios
        .get(this.API_URL + "organisations" + "?" + query)
        .then((res) => {
          this.certification_agencies = res.data.data
          this.ca_total = res.data.meta.total
          this.ca_refresh = false
          this.ca_show_loading = false

          this.ca_pagination.page = res.data.meta.current_page
          this.ca_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },

    ctg_list() {
      this.ctg_show_loading = true

      let ids = this.ctg_ids.join(",")
      let { sortBy, descending, page, itemsPerPage } = this.ctg_pagination
      let query = this.$queryString(this.ctg_pagination, {
        id: ids ? ids : null
      })

      axios
        .get(this.API_URL + "coursetypegroups" + "?" + query)
        .then((res) => {
          this.allowed_coursetypegroups = res.data.data
          this.ctg_total = res.data.meta.total
          this.ctg_refresh = false
          this.ctg_show_loading = false

          this.ctg_pagination.page = res.data.meta.current_page
          this.ctg_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },

    ct_list() {
      this.ct_show_loading = true

      let ids = this.ct_ids.join(",")
      let { sortBy, descending, page, itemsPerPage } = this.ct_pagination
      let query = this.$queryString(this.ct_pagination, {
        id: ids ? ids : null
      })

      axios
        .get(this.API_URL + "coursetypes" + "?" + query)
        .then((res) => {
          this.allowed_coursetypes = res.data.data
          this.ct_total = res.data.meta.total
          this.ct_refresh = false
          this.ct_show_loading = false

          this.ct_pagination.page = res.data.meta.current_page
          this.ct_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "organisation/" + id)
            .then((res) => {
              if (res.data.hasOwnProperty("status") && res.data.status == "has-active-tenants") {
                vm.$awn.warning(vm.$t("organisations.has_active_tenants"))
              } else {
                vm.$router.push(this.BACKEND_URL + "/organisations")
                vm.$awn.success(vm.$t("global.delete_success"))
              }
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
